function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint react/jsx-props-no-spreading: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField/TextField';
import { makeStyles, useTheme } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import MaskedInput from 'react-text-mask';
import clsx from 'clsx';
import { styles } from "./styles";
import { maskConfig, useMask } from "./masks";
import { GetEndAdornment, labelClass, outlinedInputClass } from "./styleUtils";

var TextMaskCustom = function TextMaskCustom(props) {
  var inputRef = props.inputRef,
      mask = props.mask,
      other = _objectWithoutProperties(props, ["inputRef", "mask"]);

  var _useMask = useMask(mask),
      _useMask2 = _slicedToArray(_useMask, 2),
      inputMask = _useMask2[0],
      pipeFunc = _useMask2[1];

  if (!mask) {
    return null;
  }

  return /*#__PURE__*/React.createElement(MaskedInput, _extends({}, other, {
    ref: function ref(_ref) {
      inputRef(_ref ? _ref.inputElement : null);
    },
    mask: inputMask,
    pipe: pipeFunc,
    showMask: true
  }, maskConfig));
};

export var TextFieldComponent = function TextFieldComponent(_ref2) {
  var classes = _ref2.classes,
      key = _ref2.key,
      label = _ref2.label,
      onChange = _ref2.onChange,
      value = _ref2.value,
      name = _ref2.name,
      warning = _ref2.warning,
      error = _ref2.error,
      success = _ref2.success,
      disabled = _ref2.disabled,
      mask = _ref2.mask,
      shrinkLabel = _ref2.shrinkLabel,
      placeholder = _ref2.placeholder,
      endAdornment = _ref2.endAdornment,
      _ref2$endAdornmentMar = _ref2.endAdornmentMargin,
      endAdornmentMargin = _ref2$endAdornmentMar === void 0 ? true : _ref2$endAdornmentMar,
      startAdornment = _ref2.startAdornment,
      _ref2$variantDevice = _ref2.variantDevice,
      variantDevice = _ref2$variantDevice === void 0 ? 'auto' : _ref2$variantDevice,
      maxLength = _ref2.maxLength,
      input = _objectWithoutProperties(_ref2, ["classes", "key", "label", "onChange", "value", "name", "warning", "error", "success", "disabled", "mask", "shrinkLabel", "placeholder", "endAdornment", "endAdornmentMargin", "startAdornment", "variantDevice", "maxLength"]);

  var theme = useTheme();
  var matches = useMediaQuery(theme.breakpoints.up('sm'));
  var device = variantDevice;

  if (variantDevice === 'auto') {
    if (!matches) {
      device = 'mobile';
    } else {
      device = 'web';
    }
  }

  return /*#__PURE__*/React.createElement(TextField, _extends({
    disabled: disabled,
    id: "outlined-name-".concat(name),
    name: name,
    placeholder: placeholder || label,
    label: label,
    onChange: onChange,
    InputLabelProps: {
      classes: {
        root: clsx(classes[labelClass({
          warning: warning,
          error: error,
          success: success
        })]),
        focused: classes.cssFocused
      },
      shrink: shrinkLabel
    },
    InputProps: {
      inputComponent: mask ? TextMaskCustom : undefined,
      inputProps: {
        mask: mask,
        maxLength: maxLength
      },
      className: classes.input,
      classes: {
        root: clsx(classes[outlinedInputClass({
          warning: warning,
          error: error,
          success: success
        })], classes.inputRoot),
        focused: classes.cssFocused,
        notchedOutline: classes.notchedOutline,
        inputAdornedStart: classes.adornedMarginLeft,
        inputAdornedEnd: classes.adornedMarginRight,
        adornedEnd: classes.adornedMarginEnd
      },
      startAdornment: startAdornment,
      endAdornment: /*#__PURE__*/React.createElement(GetEndAdornment, {
        warning: warning,
        error: error,
        success: success,
        endAdornmentMargin: endAdornmentMargin,
        endAdornment: endAdornment
      })
    },
    margin: device === 'mobile' ? undefined : 'dense',
    value: value,
    error: !!error,
    variant: "outlined"
  }, input));
};
var useInputUIStyles = makeStyles(styles);

var InputUI = function InputUI(_ref3) {
  var key = _ref3.key,
      _ref3$fullWidth = _ref3.fullWidth,
      fullWidth = _ref3$fullWidth === void 0 ? false : _ref3$fullWidth,
      label = _ref3.label,
      onChange = _ref3.onChange,
      value = _ref3.value,
      name = _ref3.name,
      warning = _ref3.warning,
      error = _ref3.error,
      success = _ref3.success,
      disabled = _ref3.disabled,
      placeholder = _ref3.placeholder,
      mask = _ref3.mask,
      helperText = _ref3.helperText,
      endAdornment = _ref3.endAdornment,
      startAdornment = _ref3.startAdornment,
      autoComplete = _ref3.autoComplete,
      maxLength = _ref3.maxLength,
      input = _objectWithoutProperties(_ref3, ["key", "fullWidth", "label", "onChange", "value", "name", "warning", "error", "success", "disabled", "placeholder", "mask", "helperText", "endAdornment", "startAdornment", "autoComplete", "maxLength"]);

  var classes = useInputUIStyles();
  return /*#__PURE__*/React.createElement(TextFieldComponent, _extends({
    key: key,
    error: !!error,
    helperText: error || helperText,
    fullWidth: fullWidth,
    classes: classes,
    label: label,
    placeholder: placeholder,
    onChange: onChange,
    value: value,
    name: name,
    warning: warning,
    success: success,
    disabled: disabled,
    mask: mask,
    endAdornment: endAdornment,
    startAdornment: startAdornment,
    autoComplete: autoComplete,
    maxLength: maxLength
  }, input));
};

export var Input = function Input(props) {
  return /*#__PURE__*/React.createElement(InputUI, props);
};
Input.defaultProps = {
  fullWidth: false,
  success: false,
  warning: false,
  disabled: false,
  label: null,
  onChange: null,
  error: undefined,
  mask: null,
  shrinkLabel: undefined,
  placeholder: null,
  helperText: null,
  endAdornment: null,
  endAdornmentMargin: true,
  startAdornment: null,
  autoComplete: null,
  variantDevice: 'auto'
};
var maskProp = PropTypes.oneOfType([PropTypes.oneOf(['cep', 'phone', 'cell', 'cpf', 'currency', 'cnpj', 'plate', 'cellphone', 'cpfcnpj', 'date', 'time', 'percentage', 'year']), PropTypes.array, PropTypes.func, PropTypes.bool, PropTypes.shape({
  mask: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  pipe: PropTypes.func
})]);
Input.propTypes = {
  /** Input fill div/screen width */
  fullWidth: PropTypes.bool,

  /** Disable the input */
  disabled: PropTypes.bool,

  /** Input success variant */
  success: PropTypes.bool,

  /** Input warning variant */
  warning: PropTypes.bool,

  /** Input error variant */
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),

  /** Input placeholder label */
  label: PropTypes.string,

  /** Input html name */
  name: PropTypes.string.isRequired,

  /** Fired when input changes */
  onChange: PropTypes.func,

  /** Input mask. `@tecsinapse/ui-kit` provides a preset of masks: 'cep', 'phone', 'cel', 'cpf', 'currency', 'cnpj', 'plate', 'cellphone', 'cpfcnpj', 'date', 'time', 'creditcard', 'cvv', 'mounthyear', 'percentage' and 'year'.
   * See below form more info. */
  mask: maskProp,

  /** Shrink label */
  shrinkLabel: PropTypes.bool,

  /** Placeholder when input is focused */
  placeholder: PropTypes.string,

  /** Helper text place below input */
  helperText: PropTypes.string,

  /** Adornment Icon placed at Input end */
  endAdornment: PropTypes.object,

  /** Put a margin on adornment Icon placed at Input end */
  endAdornmentMargin: PropTypes.bool,

  /** Adornment Icon placed at Input start */
  startAdornment: PropTypes.object,

  /** Autocomplete html specification for text input */
  autoComplete: PropTypes.oneOf(['on', 'off']),

  /** Variant for Input display */
  variantDevice: PropTypes.oneOf(['auto', 'web', 'mobile']),

  /** Set maxLength size for Input */
  maxLength: PropTypes.number
};
export default Input;